import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { UserChangePasswordDto } from 'projects/shared/src/lib/models/Identity/UserChangePasswordDto';
import { LoginInputModel, UserDto } from 'projects/shared/src/lib/models/User';
import { AccountService } from 'projects/shared/src/lib/services/account.service';
import { NotificationService } from 'projects/shared/src/lib/services/notification.service';
import { OAuthServiceService } from 'projects/shared/src/lib/services/o-auth-service.service';
import { TenantService } from 'projects/shared/src/lib/services/tenant.service';
import { TranslateService } from 'projects/shared/src/lib/services/translate.service';

@Component({
  selector: 'user-change-password',
  templateUrl: './user-change-password.component.html',
  styleUrls: ['./user-change-password.component.scss']
})
export class UserChangePasswordComponent implements OnInit {
  @Input('user') user!:UserDto;
  @Output() onChangePassword: EventEmitter<string> = new EventEmitter();


  passwordForm!: FormGroup;
  userId!: string;
  userName!:string;
  userEmail!:string;
  forceChangPw = false;

  constructor(private formBuilder: FormBuilder,
    private router: Router,
    private tenantService: TenantService,
    private oauthService: OAuthServiceService,
    private accountService: AccountService,
    public translate: TranslateService,
    private notificationService: NotificationService) { }

  ngOnInit(): void {
    //console.log("================> user-change-password");
    (this.user != null) ? this.forceChangPw = true : this.forceChangPw = false;
    this.createForm();
  }

  createForm() {
    this.oauthService.userData.subscribe({
      next: (data) => {
        this.userId = data.sub;
        this.userName = data.name;
        this.userEmail = data.email;
        // this.passwordForm = this.formBuilder.group({
        //   userId: [data.sub],
        //   userName: [data.name],
        //   password: [null, Validators.required],
        //   confirmPassword: [null, Validators.required]
        // });
        
      }
    });
    this.buildPasswordForm(this.userId, this.userName);
  }

  // let pwregex: RegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

  // let roles:TenantGroupRoleDto[] = [];
  // this.userForm = this.formBuilder.group({
    // email: [null, [Validators.required, Validators.pattern(emailregex)]],


  buildPasswordForm(userId: string, userName: string) {
    // let pwregex: RegExp = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@$!%*#?&^_-]).{8,}/
    let pwregex: RegExp = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@$!%*#?&^_-]).{8,}/

    if (this.forceChangPw) {
      this.passwordForm = this.formBuilder.group({
        userId: [userId],
        userName: [userName],
        oldPassword: [null], // oldPassword cannot be filled because it is not displayed
        password: [null, [Validators.required, Validators.pattern(pwregex)]],
        confirmPassword: [null, [Validators.required, Validators.pattern(pwregex)]]
      });
    } else {
      this.passwordForm = this.formBuilder.group({
        userId: [userId],
        userName: [userName],
        oldPassword: [null, [Validators.required, Validators.pattern(pwregex)]],
        password: [null, [Validators.required, Validators.pattern(pwregex)]],
        confirmPassword: [null, [Validators.required, Validators.pattern(pwregex)]]
      });
    }
  }

  cancel() {
    if (this.tenantService.currentTenantName == this.tenantService.SystemManagerAbbreviation) this.router.navigate(['/', this.tenantService.currentTenantName, 'manage-tenants']);
    else this.router.navigate(['/', this.tenantService.currentTenantName, 'all-projects']);
  }

  changePassword() {
    console.log("========> user-change-password: formValid = ", this.passwordForm.valid)
    if (this.passwordForm.valid) {
      let changePassword = new UserChangePasswordDto;
      changePassword.userId = this.passwordForm.value.userId;
      changePassword.password = this.passwordForm.value.password;
      changePassword.confirmPassword = this.passwordForm.value.confirmPassword;

      if (changePassword.password === changePassword.confirmPassword) {
        let login = new LoginInputModel();
        login.password = this.passwordForm.value.oldPassword;
        login.email = this.userEmail;
        if (!this.forceChangPw) {
          //old password has to be checked
          this.tenantService.checkPassword(login).subscribe({
            next: (success: boolean) => {
              if (success) {
                this.accountService.changePassword(changePassword).subscribe({
                  next: (x) => {
                    this.notificationService.success(`${this.translate.data["SUCCESS"]}`, `${this.translate.data["USERPASSWORDUPADTED"]}`);
                    if (this.tenantService.currentTenantName == this.tenantService.SystemManagerAbbreviation) this.router.navigate(['/', this.tenantService.currentTenantName, 'manage-tenants']);
                    else this.router.navigate(['/', this.tenantService.currentTenantName, 'all-projects']);
                    this.onChangePassword.emit("changed");
                  },
                  error: (error: any) => this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["USERPASSWORDUPADTEDERROR"]}`)
                });                  
              } else
                  this.notificationService.error(`${this.translate.data["ERROR"]}`, "Altes Passwort falsch!");
            },
            error: (error: any) => this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["USERPASSWORDUPADTEDERROR"]}`)
          });
        } else {
          //old password cannot be given in form, so there is no check
          this.accountService.changePassword(changePassword).subscribe({
            next: (x) => {
              this.notificationService.success(`${this.translate.data["SUCCESS"]}`, `${this.translate.data["USERPASSWORDUPADTED"]}`);
              if (!this.forceChangPw) this.router.navigate(['/', this.tenantService.currentTenantName, 'all-projects']);
              this.onChangePassword.emit("changed");
            },
            error: (error: any) => this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["USERPASSWORDUPADTEDERROR"]}`)
          });                  
        }
      }
      else {
        //console.log("user-change-password: pw not changed 1")
        //this.onChangePassword.emit("not changed");
        this.notificationService.warning(`${this.translate.data["WARN"]}`, `${this.translate.data["DIFERENTPASSWORDS"]} Password : ${changePassword.password} ConfirmPassword : ${changePassword.confirmPassword}`);
      }
    }
    //console.log("user-change-password: pw not changed 2")
    //this.onChangePassword.emit("not changed");
  }
}
